import { render, staticRenderFns } from "./AzRouter.vue?vue&type=template&id=40bbe705&"
import script from "./AzRouter.vue?vue&type=script&lang=js&"
export * from "./AzRouter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports